module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    staticClass: "tc",
    attrs: {
      "pageWidth": _vm.tab === 'class-wide' ?
        '900px' :
        _vm.tab === 'originality' ?
        '1000px' :
        '1200px',
      "centeredTitle": true,
      "loading": _vm.fetchingData,
      "title": _vm.getCurrentRT.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('div', [_c('pl-button', {
    class: _vm.getBtnClass('class-wide'),
    staticStyle: {
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeTab('class-wide')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/live_discussion/polls.svg",
      "alt": "",
      "height": "18px",
      "width": "22px"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Class-wide ")])]), _vm._v(" "), _c('pl-button', {
    class: _vm.getBtnClass('individual'),
    staticStyle: {
      "width": "130px",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeTab('individual')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/live_discussion/individual.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Individual ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.canRender && _vm.desiredTabIs('class-wide')) ? [_c('div', {
    staticClass: "pl-title row no-padding center-xs mt6"
  }, [_c('div', {
    staticClass: "flex-column center-xs mr4"
  }, [_c('div', {
    staticClass: "b mb4",
    staticStyle: {
      "font-size": "30px"
    },
    style: ({
      color: _vm.determineColourByPercentage(_vm.participation_rate)
    })
  }, [_vm._v("\n          " + _vm._s(Math.round(_vm.participation_rate)) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "b mb4",
    staticStyle: {
      "font-size": "30px"
    },
    style: ({
      color: _vm.determineColourByPercentage(
        _vm.class_summary_details.students_who_made_at_least_one_comment
      ),
    })
  }, [_vm._v("\n          " + _vm._s(Math.round(
    _vm.class_summary_details.students_who_made_at_least_one_comment
  )) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "b",
    staticStyle: {
      "font-size": "30px"
    },
    style: ({
      color: _vm.determineColourByPercentage(
        _vm.class_summary_details.students_who_received_at_least_one_comment
      ),
    })
  }, [_vm._v("\n          " + _vm._s(Math.round(
    _vm.class_summary_details.students_who_received_at_least_one_comment
  )) + "%\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-column items-center tl"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("Submitted a response")]), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_vm._v("Gave at least one comment")]), _vm._v(" "), _c('div', [_vm._v("Received at least one comment")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.percentages)),
      expression: "configTooltip(reflections.percentages)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n      Reflection Questions\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "b mb2 tc",
    staticStyle: {
      "font-size": "30px",
      "position": "relative"
    },
    style: ({
      color: _vm.graph_style.background_color
    })
  }, [_vm._v("\n        " + _vm._s(Math.round(_vm.class_summary_details.average_comment_length)) + " words\n        "), _c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "-11px",
      "margin-left": "10px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_modal = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-title tc"
  }, [_vm._v("Average Comment Length")]), _vm._v(" "), _c('div', {
    staticClass: "outer-graph"
  }, [_c('div', {
    staticClass: "line",
    staticStyle: {
      "left": "25%"
    }
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("10")])]), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "right": "25%"
    }
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("30")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-graph",
    style: ({
      width: _vm.graph_style.width,
      'border-radius': _vm.graph_style.border_radius,
      'background-color': _vm.graph_style.background_color,
    })
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.comment_length)),
      expression: "configTooltip(reflections.comment_length)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n      Reflection Questions\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('nlp-word-cloud'), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.word_cloud)),
      expression: "configTooltip(reflections.word_cloud)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n      Reflection Questions\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('model-submissions', {
    staticClass: "tc",
    attrs: {
      "scrollToElement": _vm.scrollToModelSubmissions
    },
    on: {
      "goToSubmission": _vm.goToSubmission
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.model_submissions)),
      expression: "configTooltip(reflections.model_submissions)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n      Reflection Questions\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('comment-rate', {
    staticClass: "tc",
    attrs: {
      "commentMedian": _vm.median_comments,
      "commentRate": _vm.comment_per_student
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('chord-diagram', {
    staticClass: "tc"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.comment_chord)),
      expression: "configTooltip(reflections.comment_chord)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text mb6"
  }, [_vm._v("\n      Reflection Questions\n    ")]), _vm._v(" "), (_vm.show_modal) ? _c('pl-dialog', {
    staticClass: "pl-subheading italics tc",
    on: {
      "close": function($event) {
        _vm.show_modal = false
      }
    }
  }, [_c('p', [_vm._v("A typical sentence is about 15 words long.")]), _vm._v(" "), _c('p', [_vm._v("\n        Our hope is that students provide at least two sentences "), _c('br'), _vm._v("\n        when giving feedback to their peers.\n      ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_modal = false
      }
    }
  }, [_vm._v("\n        OK\n      ")])], 1) : _vm._e()] : (_vm.desiredTabIs('originality')) ? [_c('br'), _c('br'), _vm._v(" "), _c('plagiarism-score', {
    ref: "plagSubmissions"
  })] : [_c('individual-roundtable-summary-overlay', {
    attrs: {
      "table_data": _vm.table_data
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-44264367!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryOverlay.vue
// module id = 1252
// module chunks = 61